module.exports = __webpack_public_path__ + "static/media/fold_other.f198c521.mp3";